import * as service from 'src/api/service'
import {
  GET_ALL_SERVICE,
  GET_SERVICE
} from 'src/store/mutation-types'

const getAllServices = ({commit, dispatch, state}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  service.getAllServices(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_SERVICE, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_SERVICE, [])
    }
  })
}

const setService = ({commit}, service) => {
  commit(GET_SERVICE, service)
}

export default{
  getAllServices,
  setService
}



// WEBPACK FOOTER //
// ./src/components/service/store/actions.js